import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MetafrenzyGuard } from 'ngx-metafrenzy';
import { PressComponent } from './press.component';

// import { BlogService } from './blog.service';

const routes: Routes = [
  {
    path: '',
    component: PressComponent,
    canActivate: [MetafrenzyGuard],
    data: {
      metafrenzy: {
        title: $localize`:@@metadataPressTitle:Wipperoz in the press`,
        tags: [
          {
            name: 'description',
            content: $localize`:@@metadataPressDescription:Wipperoz is in the news. Check out recent press coverage or get in touch. For the Wipperoz logo and more, download the media kit and see the Wipperoz brand guidelines.`
          },
          { name: 'og:title', content: $localize`:@@metadataPressOgTitle:Wipperoz in the press` },
          {
            name: 'og:description',
            content: $localize`:@@metadataPressOgDescription:Wipperoz is in the news. Check out recent press coverage or get in touch. For the Wipperoz logo and more, download the media kit and see the Wipperoz brand guidelines.`
          },
          {
            name: 'og:url',
            content: $localize`:@@metaDataPressOgUrl:https://www.wipperoz.com/en/press`
          },
          {
            name: 'twitter:url',
            content: $localize`:@@metaDataPressTwitterUrl:https://www.wipperoz.com/en/press`
          },
          {
            name: 'twitter:title',
            content: $localize`:@@metadataPressTwitterTitle:Wipperoz in the press`
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:site',
            content: '@wipperoz'
          },
          {
            name: 'twitter:description',
            content: $localize`:@@metadataBlogTwitterDescription:Wipperoz is in the news. Check out recent press coverage or get in touch. For the Wipperoz logo and more, download the media kit and see the Wipperoz brand guidelines.`
          }
        ]
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PressRoutingModule {}
